<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400"
      :style="{ zIndex: 100 }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ $t("message.check_dependency.title") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-5">
          <template v-if="!deletable">
            {{ deletable_message }}
          </template>
          <v-list v-for="dependency in data" :key="dependency.title">
            <v-list-item>
              <v-list-item-action>
                <template v-if="dependency.status === 'getting'">
                  <v-progress-circular
                    indeterminate
                  ></v-progress-circular>
                </template>
                <template v-else-if="dependency.status === 'ok'">
                  <v-icon color="teal">
                    mdi-check
                  </v-icon>
                </template>
                <template v-else-if="dependency.status === 'ng'">
                  <v-icon color="red">
                    <template v-if="is_reject">
                      mdi-close
                    </template>
                    <template v-else>
                      mdi-exclamation
                    </template>
                  </v-icon>
                </template>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ dependency.title }}
                  <template v-if="dependency.pieces >= 0">
                    :&nbsp;{{ dependency.pieces }}
                  </template>
                </v-list-item-title>
                <template v-if="'detail' in dependency">
                  <v-list-item-subtitle class="text-wrap">
                    ({{ dependency.detail }})
                  </v-list-item-subtitle>
                </template>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card flat class="pb-1 pr-3">
          <p class="text-right">
            <v-btn color="primary" :disabled="is_reject && !deletable" @click.native="agree">
              {{ $t("message.common.delete") }}
            </v-btn>
            <v-btn @click.native="cancel" ref="cancel">
              {{ $t("message.common.prev") }}
            </v-btn>
          </p>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { http_error } from "../js/http_error";

export default {
  name: 'check_dependency',
  mixins: [http_error],
  props: {
    is_reject: Boolean,
    deletable_message: String
  },
  data: () => ({
    module_id: "6B",

    dialog: false,
    resolve: null,
    reject: null,
    data: []
  }),
  methods: {
    open(dependencies) {
      this.dialog = true
      setTimeout(() => {
        this.$refs.cancel.$el.focus();
      });
      var data = [];
      var promiseArray = [];
      for(var dependency of dependencies){
        var take_over = {
          parent: this,
          data: {
            title: dependency.title,
            status: "getting",
            pieces: -1
          }
        }
        if("detail" in dependency){
          take_over.data.detail = dependency.detail;
        }
        this.$http.get(this.$store.getters.api_endpoint + "/" + dependency.path)
          .then(function(response){
            if(this.parent.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            if(response.data instanceof Array){
              this.data.status = "ok";
              this.data.pieces = 0;
              for(var r of response.data){
                // 200だとNG
                if("enable" in r && !r.enable){
                  continue;
                }else{
                  this.data.status = "ng";
                  this.data.pieces++;
                }
              }
            }else{
              // 200だとNG
              if("enable" in response.data && !response.data.enable){
                this.data.status = "ok";
                this.data.pieces = 0;
              }else{
                this.data.status = "ng";
                this.data.pieces = 1;
              }
            }
          }.bind(take_over))
          .catch(function(error){
            if(this.parent.http_error(error)){
              if(error.response.status === 404){
                // 404だとOK
                this.data.status = "ok";
                this.data.pieces = 0;
              }else{
                this.parent.$store.commit("setNotification", {
                  type: "error",
                  message: error.response.data
                });
              }
            }
          }.bind(take_over));
        data.push(take_over.data);
      }
      this.data = data;
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
      this.remove_range()
    },
    remove_range(){
      const selection = window.getSelection();
      if(selection.toString()){
        const range = selection.getRangeAt(0);
        selection.removeAllRanges(range);
      }
    }
  },
  computed: {
    deletable: function(){
      if(this.data.length == 0){
        return false;
      }
      for(var dependency of this.data){
        if(dependency.status != "ok"){
          return false;
        }
      }
      return true;
    }
  }
}
</script>
